/* Shared Build Your Set calibration and glyph rendering for bundle popups. */
(function () {
  'use strict';
  window.BundleMonogramPreview = function (container, rec, draft, glyphSample) {
    var cfg = { monogram: { glyphSample: glyphSample } };
    var GRID_IMAGE_WIDTH = 900;
    function fontName() { var f = window.monogram_font_faces; return ((f && f[0] && f[0].title) || 'Serif').toLowerCase(); }
    function sizeName() { var s = window.monogram_font_sizes; return ((s && s[0] && s[0].title) || '36pt').toLowerCase(); }
    function foilValue(f) { return f.title.toLowerCase(); }
    function foilLabel(f) { return f.title; }
    function upscale(url) { return url.replace(/([?&])width=\d+/, '$1width=900'); }
  // AU-calibrated preview photos and coordinates, mapped to US variant IDs by SKU.
  var monogramPositions = {
  "50143319195841": {
    "source": "Duo_Vanity_Case__Noir_Croc_be68cd22-7303-4044-bfff-5be8b1a56cb2.png?v=1785945698",
    "x": 260,
    "y": 415,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_NoirCroc_7be5679d-156f-443b-b291-3466a77048fe.png?v=1785245715&width=900",
    "scale": 0.75
  },
  "40316386443457": {
    "source": "Duo_Vanity_Case_Black_1.png?v=1785945698",
    "x": 260,
    "y": 414,
    "image": "//etoile.com/cdn/shop/files/Duo_Vanity_Case_Black_1.png?v=1785246212&width=900",
    "scale": 0.75
  },
  "48768983302337": {
    "source": "Duo_Vanity_Case__Espresso_4b884521-6225-4cb5-a38e-65171c29702d.png?v=1785945698",
    "x": 257,
    "y": 414,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_Espresso.png?v=1785245716&width=900",
    "scale": 0.75
  },
  "47614734565569": {
    "source": "Duo_Vanity_Case__Ginger_Brown_ddf7e773-abd4-4821-acdd-e1210ef004f2.png?v=1785945698",
    "x": 259,
    "y": 415,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_GingerBrown.png?v=1785245716&width=900",
    "scale": 0.75
  },
  "49582382252225": {
    "source": "Duo_Vanity_Case_Pebble_1.png?v=1786107124",
    "x": 258,
    "y": 410,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_Pebble_a656e916-b851-4479-aab5-fb4a260d56ab.png?v=1785245715&width=900",
    "scale": 0.75
  },
  "47433737994433": {
    "source": "Duo_Vanity_Case__Ginger_Brown_2_41597bcb-e2b5-4e91-bb93-c2d778ad0fd8.png?v=1785945698",
    "x": 262,
    "y": 410,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_GingerBrown_2.png?v=1785245715&width=900",
    "scale": 0.75
  },
  "47433779740865": {
    "source": "Duo_Vanity_Case__Blush_d6535c8a-63bf-4a93-bf15-999b40ed56cc.png?v=1785945699",
    "x": 259,
    "y": 417,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_Blush.png?v=1785245716&width=900",
    "scale": 0.75
  },
  "49941686354113": {
    "source": "Duo_Vanity_Case__Crush_53142d68-a8b0-41d5-9b6b-51af00fcb89e.png?v=1785945698",
    "x": 260,
    "y": 414,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_Crush.png?v=1785245715&width=900",
    "scale": 0.75
  },
  "47433748840641": {
    "source": "Duo_Vanity_Case__Burgundy_07b6b3d1-f20f-43e1-b229-b9c6be142190.png?v=1785945698",
    "x": 262,
    "y": 411,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_Burgundy_1a4ff177-0855-4d9b-8ab3-29626b3430a4.png?v=1785245715&width=900",
    "scale": 0.75
  },
  "49254195691713": {
    "source": "Duo_Vanity_Case__Robin_Blue.png?v=1785945698",
    "x": 257,
    "y": 412,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_RobinBlue.png?v=1785245715&width=900",
    "scale": 0.75
  },
  "49582374682817": {
    "source": "Duo_Vanity_Case__Navy_65889e8f-22b6-4412-b284-2c31d6df5e75.png?v=1785945698",
    "x": 258,
    "y": 414,
    "image": "//etoile.com/cdn/shop/files/DuoVanityCase_Navy.png?v=1785245715&width=900",
    "scale": 0.75
  },
  "50143321424065": {
    "source": "Vanity_Case__Noir_Croc_8f5d3cca-9346-48f7-baf1-4b4dfbeb539c.png?v=1785946089",
    "x": 259,
    "y": 417,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Noir_Croc_8f5d3cca-9346-48f7-baf1-4b4dfbeb539c.png?v=1785245709&width=900",
    "scale": 0.75
  },
  "40537447039169": {
    "source": "Vanity_Case__Black_7001bf58-2577-4d08-b787-549a340312af.png?v=1785946089",
    "x": 260,
    "y": 418,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Black_7001bf58-2577-4d08-b787-549a340312af.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "48769330249921": {
    "source": "Vanity_Case__Espresso_b87f0742-8830-4113-b59a-c95316dedd3c.png?v=1785946089",
    "x": 262,
    "y": 415,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Espresso_b87f0742-8830-4113-b59a-c95316dedd3c.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "49582404239553": {
    "source": "Vanity_Case__Pebble_1dc4002a-1168-435c-ae55-e743db36cfec.png?v=1785946089",
    "x": 259,
    "y": 414,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Pebble_1dc4002a-1168-435c-ae55-e743db36cfec.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "47614747345089": {
    "source": "Vanity_Case__Ginger_Brown_8fb8c1a6-49be-4ac3-ac99-49d7e1f5a53d.png?v=1785946089",
    "x": 262,
    "y": 414,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Ginger_Brown_8fb8c1a6-49be-4ac3-ac99-49d7e1f5a53d.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "47433414541505": {
    "source": "Vanity_Case__Beige.png?v=1785946088",
    "x": 260,
    "y": 412,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Beige.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "47433457270977": {
    "source": "Vanity_Case__Black_7001bf58-2577-4d08-b787-549a340312af.png?v=1785946089",
    "x": 263,
    "y": 416,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Off_White_fb2d5777-6231-4716-ae15-548afb75e5da.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "47433448784065": {
    "source": "Vanity_Case__Blush.png?v=1785946089",
    "x": 260,
    "y": 417,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Blush.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "47433424339137": {
    "source": "Vanity_Case__Burgundy_f1528dfb-e35b-4a6f-b3b1-448be9aa0d71.png?v=1785946089",
    "x": 262,
    "y": 411,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Burgundy_f1528dfb-e35b-4a6f-b3b1-448be9aa0d71.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "49254195855553": {
    "source": "Vanity_Case__Robin_Blue.png?v=1785946089",
    "x": 257,
    "y": 413,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Robin_Blue.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "49582404894913": {
    "source": "Vanity_Case__Navy_23df1b4f-a525-43dc-9c26-93daf178ce62.png?v=1785946089",
    "x": 260,
    "y": 414,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Navy_23df1b4f-a525-43dc-9c26-93daf178ce62.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "49941723381953": {
    "source": "Vanity_Case__Crush_6176bbf2-542b-4365-9aa9-511d057f1a9b.png?v=1785946089",
    "x": 262,
    "y": 414,
    "image": "//etoile.com/cdn/shop/files/Vanity_Case__Crush_6176bbf2-542b-4365-9aa9-511d057f1a9b.png?v=1785245710&width=900",
    "scale": 0.75
  },
  "50143322144961": {
    "source": "Mini_Vanity_Case__Noir_Croc_6da365e1-0b43-4c16-831c-81892b80b850.png?v=1785946583",
    "x": 260,
    "y": 413,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Noir_Croc_65531130-6715-4aca-b05b-a89a9c8e83b6.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "42729064726721": {
    "source": "Mini_Vanity_Case__Black_5fcfc394-fb21-4838-b144-62adae2d8df8.png?v=1785946583",
    "x": 257,
    "y": 414,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Black_0a9a0a5d-5252-4f57-8da8-57da418c0f81.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "48769407779009": {
    "source": "Mini_Vanity_Case__Espresso_86aa6edc-ff71-47fd-88d1-8df6051e9f71.png?v=1785946583",
    "x": 251,
    "y": 410,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Espresso_e8559919-8e14-4c9e-94a1-f16cd91fc36f.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "49582408827073": {
    "source": "Mini_Vanity_Case__Pebble_dba92749-c3d6-4425-82a3-03e914363881.png?v=1785946583",
    "x": 257,
    "y": 412,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Pebble_b53ae42a-4ede-4e90-8578-64f809baaad3.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "47614742298817": {
    "source": "Mini_Vanity_Case__Ginger_Brown_2d103df6-889e-43d7-bea0-eed4bcddbf61.png?v=1785946583",
    "x": 256,
    "y": 408,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Ginger_Brown_65cb19b4-f8d6-4ced-a1ab-6e17ae3db02c.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "47437146882241": {
    "source": "Mini_Vanity_Case_Beige_1.png?v=1785946583",
    "x": 264,
    "y": 415,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Beige.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "47437627850945": {
    "source": "Mini_Vanity_Case__Blush.png?v=1785946583",
    "x": 259,
    "y": 412,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Blush.png?v=1785245959&width=900",
    "scale": 0.75
  },
  "47437200556225": {
    "source": "Mini_Vanity_Case__Burgundy_38e58a59-11aa-4fc7-b37c-73d43add4a54.png?v=1785946584",
    "x": 255,
    "y": 412,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Burgundy_e13110a1-0db9-4196-bb04-fadfa0bbf149.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "49254195724481": {
    "source": "Mini_Vanity_Case__Robin_Blue.png?v=1785946583",
    "x": 258,
    "y": 412,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Robin_Blue.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "49582408892609": {
    "source": "Mini_Vanity_Case__Navy_7cebbb3d-0f62-40d9-a88b-2b66d0b8c2b5.png?v=1785946583",
    "x": 258,
    "y": 413,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Navy_70815339-a244-40ec-9cf7-11d2b192fe5c.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "49941703917761": {
    "source": "Mini_Vanity_Case__Crush_4a38bed8-756a-4713-a9c3-a86a44780960.png?v=1785946583",
    "x": 257,
    "y": 411,
    "image": "//etoile.com/cdn/shop/files/Mini_Vanity_Case__Crush_375b39ec-c545-4c62-8891-9a95080e6899.png?v=1785245960&width=900",
    "scale": 0.75
  },
  "50143322931393": {
    "source": "Oval_Toiletry_Case__Noir_Croc_240efb5d-5f61-4a82-bb10-8165055ff984.png?v=1785947604",
    "x": 256,
    "y": 423,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Noir_Croc_240efb5d-5f61-4a82-bb10-8165055ff984.png?v=1785246305&width=900",
    "scale": 0.75
  },
  "48737190019265": {
    "source": "Oval_Toiletry_Case__Black_5d2c4247-7df5-4061-b653-3920f34265b9.png?v=1785947604",
    "x": 260,
    "y": 423,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Black_5d2c4247-7df5-4061-b653-3920f34265b9.png?v=1785246305&width=900",
    "scale": 0.75
  },
  "48929680097473": {
    "source": "Oval_Toiletry_Case__Espresso_a23d42b4-dc48-47fb-91a7-5ba804c378e9.png?v=1785947604",
    "x": 264,
    "y": 420,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Espresso_a23d42b4-dc48-47fb-91a7-5ba804c378e9.png?v=1785246305&width=900",
    "scale": 0.75
  },
  "49582431109313": {
    "source": "Oval_Toiletry_Case__Pebble_79aa3fb4-8383-4d5d-ab55-2ee7502294e1.png?v=1785947604",
    "x": 260,
    "y": 423,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Pebble_79aa3fb4-8383-4d5d-ab55-2ee7502294e1.png?v=1785246305&width=900",
    "scale": 0.75
  },
  "48730258309313": {
    "source": "Oval_Toiletry_Case__Ginger_Brown_5fff7fd6-47b5-4f8f-a98a-93f8cfb47583.png?v=1785947604",
    "x": 258,
    "y": 427,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Ginger_Brown_5fff7fd6-47b5-4f8f-a98a-93f8cfb47583.png?v=1785246305&width=900",
    "scale": 0.75
  },
  "49254122127553": {
    "source": "Oval_Toiletry_Case__Lavender_Pink_702bf0d8-f07f-4e61-91f0-91bb982a7686.png?v=1785947604",
    "x": 258,
    "y": 422,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Lavender_Pink_702bf0d8-f07f-4e61-91f0-91bb982a7686.png?v=1785246305&width=900",
    "scale": 0.75
  },
  "49254122160321": {
    "source": "Oval_Toiletry_Case__Burgundy_0614af1b-0de6-4e84-bb66-68e2bf5c6cd4.png?v=1785947604",
    "x": 258,
    "y": 423,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Burgundy_0614af1b-0de6-4e84-bb66-68e2bf5c6cd4.png?v=1785246305&width=900",
    "scale": 0.75
  },
  "49254195757249": {
    "source": "Oval_Toiletry_Case__Robin_Blue.png?v=1785947604",
    "x": 257,
    "y": 412,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Robin_Blue.png?v=1785246433&width=900",
    "scale": 0.75
  },
  "49582431273153": {
    "source": "Oval_Toiletry_Case__Navy_cbaa86c7-0d2f-495e-8e84-ff2d2ba7227c.png?v=1785947604",
    "x": 255,
    "y": 424,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Navy_cbaa86c7-0d2f-495e-8e84-ff2d2ba7227c.png?v=1785246305&width=900",
    "scale": 0.75
  },
  "49942142320833": {
    "source": "Oval_Toiletry_Case__Crush_eaba7fe6-fdf5-4f46-aab8-a89e912a4c67.png?v=1785947604",
    "x": 256,
    "y": 428,
    "image": "//etoile.com/cdn/shop/files/Oval_Toiletry_Case__Crush_eaba7fe6-fdf5-4f46-aab8-a89e912a4c67.png?v=1785246305&width=900",
    "scale": 0.75
  },
  "40316393652417": {
    "source": "JetSetterTravelCaseBlack_3945229d-bd66-47fd-b87e-fff59a333d73.png?v=1786663106",
    "x": 254,
    "y": 363,
    "image": "//etoile.com/cdn/shop/files/JetSetterTravelCaseBlack.png?v=1786662901&width=900",
    "scale": 0.68
  },
  "47430846218433": {
    "source": "JetSetterTravelCase_Beige_4d56c292-2495-4d2c-902d-301c0eed4479.png?v=1786361569",
    "x": 260,
    "y": 375,
    "image": "//etoile.com/cdn/shop/files/JetSetterTravelCase_Beige.png?v=1786361488&width=900",
    "scale": 0.68
  },
  "47430843269313": {
    "source": "JSOffWhiteAnnotated.png?v=1756671430",
    "x": 254,
    "y": 359,
    "image": "//etoile.com/cdn/shop/files/JetSetterTravelCase-OffWhite_2.png?v=1786371336&width=900",
    "scale": 0.68
  },
  "47430847398081": {
    "source": "Jet-Setter_Grey_top-makeup_74909b90-5b66-43b0-8548-e52bea3fd0fd.png?v=1756671430",
    "x": 264,
    "y": 374,
    "image": "//etoile.com/cdn/shop/files/JetSetterTravelCase-Grey.png?v=1786371336&width=900",
    "scale": 0.6
  },
  "47430843793601": {
    "source": "JetSetterTravelCase_Burgundy_7f4bd54e-02db-4c9a-bd7e-d7127f167dee.png?v=1786370544",
    "x": 263,
    "y": 361,
    "image": "//etoile.com/cdn/shop/files/JetSetterTravelCase_Burgundy.png?v=1786371337&width=900",
    "scale": 0.68
  },
  "47430844711105": {
    "source": "JetSetterTravelCase_Cobalt2_a2fbf043-1929-49ec-ae8f-9cb2da6bc80c.png?v=1756671430",
    "x": 250,
    "y": 363,
    "image": "//etoile.com/cdn/shop/files/JetSetterTravelCase-Cobalt.png?v=1786371336&width=900",
    "scale": 0.68
  },
  "47430844252353": {
    "source": "JSForestAnnotated.png?v=1756671430",
    "x": 265,
    "y": 363,
    "image": "//etoile.com/cdn/shop/files/Jet_Setter_Travel_Case__Forest_0467b9cc-9eb4-4ea7-856b-fc486bfa22c3.png?v=1789547651&width=900",
    "scale": 0.68
  },
  "47430845989057": {
    "source": "JetSetterTravelCase_LavenderPink_ae53d9fc-6c81-458e-b917-71181c3b286b.png?v=1786370544",
    "x": 257,
    "y": 366,
    "image": "//etoile.com/cdn/shop/files/JetSetterTravelCase_LavenderPink.png?v=1786371336&width=900",
    "scale": 0.68
  },
  "47430845300929": {
    "source": "JetSetterTravelCase_Lilac2_76275292-9329-4668-8e57-49d7cf8bde06.png?v=1756671430",
    "x": 269,
    "y": 366,
    "image": "//etoile.com/cdn/shop/files/JetSetterTravelCase_Lilac.png?v=1786371336&width=900",
    "scale": 0.68
  },
  "40316379300033": {
    "source": "Clear_Makeup_Travel_Case__Black_fb864c1e-4def-48af-9abe-203bd509baea.png?v=1786744702",
    "x": 257,
    "y": 275,
    "image": "//etoile.com/cdn/shop/files/Clear_Makeup_Travel_Case__Black_b6ab2701-7437-4875-be5f-bad6a649dafe.png?v=1786733874&width=900",
    "scale": 0.75
  },
  "47430003130561": {
    "source": "USClearmakeupTravelCase_GingerBrown.png?v=1785947771",
    "x": 258,
    "y": 284,
    "image": "//etoile.com/cdn/shop/files/Clear_Makeup_Travel_Case__Beige.png?v=1785247182&width=900",
    "scale": 0.75
  },
  "48948005404865": {
    "source": "ClearMakeupTravelCase_Burgundy.png?v=1785947771",
    "x": 258,
    "y": 277,
    "image": "//etoile.com/cdn/shop/files/Clear_Makeup_Travel_Case__Burgundy_b470e840-f724-4597-ae8d-32222b7f2393.png?v=1785247183&width=900",
    "scale": 0.75
  },
  "48948007436481": {
    "source": "NEWClearMakeupTravelCaseCobalt.png?v=1785947877",
    "x": 257,
    "y": 280,
    "image": "//etoile.com/cdn/shop/files/Clear_Makeup_Travel_Case__Cobalt.png?v=1785247486&width=900",
    "scale": 0.75
  },
  "48948005372097": {
    "source": "ClearMakeupTravelCase_ForestNew.png?v=1785947771",
    "x": 256,
    "y": 277,
    "image": "//etoile.com/cdn/shop/files/Clear_Makeup_Travel_Case__Forest.png?v=1786366786&width=900",
    "scale": 0.75
  },
  "48948007502017": {
    "source": "Clear_Makeup_Travel_Case__Black_fb864c1e-4def-48af-9abe-203bd509baea.png?v=1786744702",
    "x": 256,
    "y": 278,
    "image": "//etoile.com/cdn/shop/files/Clear_Makeup_Travel_Case__Grey_e1d51fa1-9834-42da-8fba-873d18b3bde6.png?v=1785247182&width=900",
    "scale": 0.75
  },
  "47430006407361": {
    "source": "ClearMakeupTravelCase_LavenderPinkNEW.png?v=1785947771",
    "x": 258,
    "y": 278,
    "image": "//etoile.com/cdn/shop/files/Clear_Makeup_Travel_Case__Lavender_Pink_Old_6718aee1-cb3f-44e9-a6cf-82507114bb46.png?v=1785247182&width=900",
    "scale": 0.75
  },
  "48948005273793": {
    "source": "ClearMakeupTravelCase_Lilac.png?v=1785947771",
    "x": 253,
    "y": 286,
    "image": "//etoile.com/cdn/shop/files/Clear_Makeup_Travel_Case__Lilac.png?v=1785247486&width=900",
    "scale": 0.75
  }
};

  function buildLivePreview(container, rec, draft) {
    var ns = 'http://www.w3.org/2000/svg';
    var data = rec.variant.preview || {};
    var settings = data.settings || {};
    var position = monogramPositions[String(rec.variant.id)];
    var sourceKey = String(data.image || '').split('/').pop().replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    if (position && position.source !== sourceKey) position = null;
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 516 600');
    svg.setAttribute('class', 'bys-mono__canvas');
    svg.setAttribute('role', 'img');
    var photo = document.createElementNS(ns, 'image');
    photo.setAttribute('href', (position && position.image) || data.image || upscale(rec.variant.image || '', GRID_IMAGE_WIDTH));
    photo.setAttribute('width', '516'); photo.setAttribute('height', '600');
    photo.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.appendChild(photo);
    var lettering = document.createElementNS(ns, 'g');
    lettering.setAttribute('class', 'bys-mono__initials');
    svg.appendChild(lettering); container.appendChild(svg);
    var version = 0;
    function update() {
      var current = ++version;
      lettering.replaceChildren();
      var label = rec.product.title + ' - ' + rec.variant.title;
      svg.setAttribute('aria-label', label);
      var x = Number(settings.horizontal_letter_position);
      var y = Number(settings.vertical_letter_position);
      var w = Number(settings.width_container_desktop);
      var h = Number(settings.height_container_desktop);
      if (!draft.letters || !draft.foil || !cfg.monogram.glyphSample ||
          !Number.isFinite(x) || !Number.isFinite(y) || !(w > 0) || !(h > 0)) return;
      var scale = position ? position.scale : (Number(settings.letter_scale) / 100 || 1);
      var height = 26 * scale;
      var centreX = position ? position.x : (x + w / 2) * 5.16;
      // PDP margin-top percentages resolve against the image width.
      var centreY = position ? position.y : y * 5.16 + h * 3 - 2.5 * scale;
      var base = cfg.monogram.glyphSample.split('/').slice(0, -1).join('/') + '/';
      var prefix = fontName() + '_' + sizeName() + '_' + foilValue(draft.foil) + '_';
      var chars = draft.letters.split('');
      svg.setAttribute('aria-label', label + ', monogram ' + draft.letters + ' in ' + foilLabel(draft.foil) + ' foil');
      var loaded = 0, glyphs = [];
      chars.forEach(function (letter, index) {
        var asset = new Image();
        asset.onload = function () {
          if (current !== version) return;
          glyphs[index] = { url: asset.src, width: height * asset.naturalWidth / asset.naturalHeight };
          if (++loaded !== chars.length) return;
          var total = glyphs.reduce(function (sum, glyph) { return sum + glyph.width; }, 0);
          var left = centreX - total / 2;
          glyphs.forEach(function (glyph) {
            var image = document.createElementNS(ns, 'image');
            image.setAttribute('href', glyph.url);
            image.setAttribute('x', left); image.setAttribute('y', centreY - height / 2);
            image.setAttribute('width', glyph.width); image.setAttribute('height', height);
            lettering.appendChild(image); left += glyph.width;
          });
        };
        asset.src = base + prefix + letter.toLowerCase() + '.png';
      });
    }
    update();
    return update;
  }


    container.replaceChildren();
    return buildLivePreview(container, rec, draft);
  };
})();


